import {BaseConfig} from "../../infrastructure/config/base-config";
import {EntityDescriptionModuleTerms} from "./entity-description.module.terms";

export class EntityDescriptionModuleConfig extends BaseConfig {
  static injectables = [EntityDescriptionModuleTerms];

  constructor(terms: EntityDescriptionModuleTerms){
    super('entityDescriptionModule', null, terms);
  }
}
